import React from 'react';
import { Typography } from '@material-ui/core';
import { TOTAL_TRIAL_STEPS } from '../CreateTrialAccountConsts';
import { useCampfireTheme } from '../../../../theme/useCampfireTheme';

export const StepHeader = ({ step, title, subtitle }: { step: number; title: string; subtitle: string }) => {
  const { theme } = useCampfireTheme();

  return (
    <>
      <Typography variant='caption' color='textSecondary'>
        {`Step ${step} of ${TOTAL_TRIAL_STEPS}`}
      </Typography>
      <Typography
        variant='h3'
        style={{ fontWeight: 700, fontSize: '24px', letterSpacing: '-2%', color: '#343434', marginTop: '4px' }}
      >
        {title}
      </Typography>
      <Typography style={{ color: theme.color.grey.neutralBrand400 }}>{subtitle}</Typography>
    </>
  );
};
